// GENERATED FILE — do not edit by hand.
// Overwritten at build time by scripts/generate-version.js.
export const APP_VERSION = '55889672831364e33453ca2dbc9e285bf8e0bd2b';
export const BUILD_NUMBER = '255';
export const BUILD_TIMESTAMP = '2026-09-29T08:25:53.888Z';
